import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ organizationId = '', id = '', ...params }) => {
  return await dponetAPI.get(
    `/backoffice/organizations/${organizationId}/organization_companies/${id}`,
    {
      params,
    },
  )
}

const create = async ({ id = '', ...params }) => {
  return await dponetAPI.post(
    `/backoffice/organizations/${id}/organization_companies`,
    {
      ...params,
    },
  )
}

const update = async ({ organizationId = '', id = '', ...params }) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}/organization_companies/${id}`,
    {
      ...params,
    },
  )
}

const destroy = async ({ organizationId = '', id = '' }) => {
  return await dponetAPI.delete(
    `/backoffice/organizations/${organizationId}/organization_companies/${id}`,
  )
}

const organizationCompanies = { get, create, destroy, update }

export default organizationCompanies
